import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { ThemeMode } from "../../../util/theme";
import { getActionsPadding } from "./modalTheme";

export interface StyledModalActionsProps {
    themeMode: ThemeMode;
}

export const StyledModalActions = styled("div")`
    padding: ${getActionsPadding};
    display: inline-flex;
    align-items: center;
    gap: ${sizes.xSmall}px;
`;
